import React from 'react';
import GenericCrudPage from '../../../components/Generic/GenericCrudPage';
import { useAppSelector } from '../../../store/reduxHooks';
import {
  useGetAllQuery,
  useGetChangeTypeQuery,
  useTestContactUsMutation,
} from '../../../services/rtkQueryServices';
import { Button, Fab, Grid } from '@mui/material';
import { ChangeReadOnly } from './ChangeForm';
import NavigationIcon from '@mui/icons-material/Navigation';

export default function TypeChangePage({}: any) {
  const user = useAppSelector((state) => state.auth.user);
  const [contactUsDemoApi, { isLoading, isSuccess }] =
    useTestContactUsMutation();

  return (
    <>
      <GenericCrudPage
        key='change-type-page'
        tableColumns={[
          {
            field: 'name',
            headerName: 'Name',
            width: 200,
          },
          {
            field: 'type',
            headerName: 'Type',
            width: 200,
          },
          {
            field: 'changeTo',
            headerName: 'Change to',
            width: 200,
          },
        ]}
        singularName='change'
        pageTitle='Change Type'
        resource='change-types'
        allowAdd={false}
        allowEdit={false}
        allowDelete={false}
        allowApprove={true}
        allowReject={true}
        ReadOnlyComponent={ChangeReadOnly}
        EditFormComponent={(data: any, setReadOnly: any) => <div />}
        newPayload={{
          title: '',
          name: '',
          about: '',
        }}
        validateFn={(data: any) => {
          return [true, []];
        }}
      />
    </>
  );
}
